<svg
  width="14"
  height="27"
  viewBox="0 0 14 27"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.2501 0.58374V5.75041H10.7501C9.88762 5.75041 9.50012 6.79666 9.50012 7.68791V10.9171H13.2501V16.0837H9.50012V26.4171H4.50012V16.0837H0.750122V10.9171H4.50012V5.75041C4.50012 4.38012 5.02691 3.06596 5.96459 2.09702C6.90227 1.12808 8.17404 0.58374 9.50012 0.58374H13.2501Z"
    fill="currentColor"
  />
</svg>
